import { useContext } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import { ApiMethod } from '../models/api-types.type';
import { routes } from '../../assets/constants';

export type TeamDeviceKind = 'extension' | 'phone';

/** A teammate's device whose visits are our own testing (API: team_devices). */
export interface TeamDevice {
  _id: string;
  owner: string;
  label: string;
  kind: TeamDeviceKind;
  createdAt?: string;
  createdBy?: string;
  lastSeenAt?: string;
  revokedAt?: string;
  revokedBy?: string;
}

/** Ardealy staff: the team's devices, and their keys (returned once, at creation). */
export const useTeamDevicesApi = () => {
  const { sendAuthGuardedRequest } = useContext(AuthContext);
  const r = routes.internalTraffic;
  return {
    list: () => sendAuthGuardedRequest(ApiMethod.GET, r.devices) as Promise<TeamDevice[]>,
    create: (body: { label: string; kind: TeamDeviceKind; owner?: string }) =>
      sendAuthGuardedRequest(ApiMethod.POST, r.devices, body) as Promise<{ device: TeamDevice; key: string }>,
    revoke: (id: string) => sendAuthGuardedRequest(ApiMethod.DELETE, r.device(id)) as Promise<TeamDevice>,
  };
};
